// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { seiTestnet as _seiTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the seiTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1328
 * Chain Name: Sei Testnet
 * Default Block Explorer: https://seitrace.com
 * Default RPC URL: https://evm-rpc-testnet.sei-apis.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { seiTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: seiTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const seiTestnet = createCommon({
	..._seiTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
